import React, { createContext, useContext, ReactNode } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components/native';
import { aiaTheme, Theme } from './aiaTheme';

const ThemeContext = createContext<Theme>(aiaTheme);

interface ThemeProviderProps {
  children: ReactNode;
  theme?: Theme;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children, theme = aiaTheme }) => (
  <ThemeContext.Provider value={theme}>
    <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>
  </ThemeContext.Provider>
);

export const useTheme = (): Theme => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
